// extracted by mini-css-extract-plugin
export default {"adminProducts":"AdminProducts_adminProducts__KDfpq"};